import React, { useState } from 'react';
import { connect } from 'react-redux';
import Recorder from 'components/ui/MediaRecorder';
import { mediaLocales } from 'components/ui/ZiggeoVideo/ziggeoHelpers';
import InfoTooltip from 'components/shared/InfoTooltip';
import EmbedForm from '../EmbedForm';

const ProviderIndependentVideoEmbed = props => {
  const {
    submitRecording,
    apiKey,
    onUrlInput,
    onSubmit,
    provider,
    elementId,
    currentUserId,
  } = props;
  const [recordScreen, setRecordScreen] = useState(true);
  const [canRecordScreen, setCanRecordScreen] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [recordWebcam, setRecordWebcam] = useState(true);
  const [recordingNotSupported, setRecordingNotSupported] = useState(false);

  const saveVideo = data => {
    submitRecording(data.url);
  };

  const toggleScreen = () => {
    setRecordScreen(!recordScreen);
  };

  const toggleWebcam = () => {
    setRecordWebcam(!recordWebcam);
  };

  const onRecordingNotSupported = recordingTypeUnsupported => {
    if (!recordingNotSupported && recordingTypeUnsupported === 'all') {
      setRecordingNotSupported(true);
    } else if (canRecordScreen && recordingTypeUnsupported === 'screen') {
      setCanRecordScreen(false);
      setRecordScreen(false);
    }
  };

  const onProcessing = () => {
    setProcessing(!processing);
  };

  return (
    <div className="lh-1 EditorElement-uploadArea">
      {!recordWebcam && !recordScreen && (
        <Recorder
          provider={provider}
          saveMedia={saveVideo}
          apiKey={apiKey}
          allowUpload
          allowWebcam={false}
          mediaLocales={mediaLocales}
          onRecording={onProcessing}
          onRecordingStopped={onProcessing}
          onUploading={onProcessing}
          onBrowserRecordingNotSupported={onRecordingNotSupported}
          elementId={elementId}
          currentUserId={currentUserId}
          trackEvents
        />
      )}

      {recordWebcam && !recordScreen && (
        <Recorder
          provider={provider}
          saveMedia={saveVideo}
          apiKey={apiKey}
          allowUpload
          allowWebcam
          mediaLocales={mediaLocales}
          onRecording={onProcessing}
          onRecordingStopped={onProcessing}
          onUploading={onProcessing}
          onBrowserRecordingNotSupported={onRecordingNotSupported}
          elementId={elementId}
          currentUserId={currentUserId}
          trackEvents
        />
      )}

      {!recordWebcam && recordScreen && (
        <Recorder
          provider={provider}
          saveMedia={saveVideo}
          apiKey={apiKey}
          allowUpload
          allowWebcam={false}
          allowScreen
          mediaLocales={mediaLocales}
          onRecording={onProcessing}
          onRecordingStopped={onProcessing}
          onUploading={onProcessing}
          onBrowserRecordingNotSupported={onRecordingNotSupported}
          elementId={elementId}
          currentUserId={currentUserId}
          trackEvents
        />
      )}

      {recordWebcam && recordScreen && (
        <Recorder
          provider={provider}
          saveMedia={saveVideo}
          apiKey={apiKey}
          allowUpload
          allowWebcam={false}
          multiStreamEnabled
          mediaLocales={mediaLocales}
          onRecording={onProcessing}
          onRecordingStopped={onProcessing}
          onUploading={onProcessing}
          onBrowserRecordingNotSupported={onRecordingNotSupported}
          elementId={elementId}
          currentUserId={currentUserId}
          trackEvents
        />
      )}

      {!processing && (
        <>
          {recordingNotSupported && (
            <span className="fs-i">
              {t('lessons.editor.embeds.video.browser_not_supported')}
            </span>
          )}

          {!recordingNotSupported && (
            <>
              <div className="d-f">
                <div>
                  <label className="mr-4" htmlFor="screen">
                    {t('lessons.editor.media_recording.types.screen')}
                  </label>
                  <input
                    type="checkbox"
                    name="screen"
                    className="mr-12"
                    checked={recordScreen && canRecordScreen}
                    onChange={toggleScreen}
                    disabled={!canRecordScreen}
                  />
                  {!canRecordScreen && (
                    <InfoTooltip
                      tooltip={t(
                        'questions.question.media_recording.unsupported',
                      )}
                      className="ml-4 tooltip-fixedWidth"
                    />
                  )}
                </div>
                <div>
                  <label className="mr-4 ml-12" htmlFor="webcam">
                    {t('lessons.editor.media_recording.types.webcam')}
                  </label>
                  <input
                    type="checkbox"
                    name="webcam"
                    checked={recordWebcam}
                    onChange={toggleWebcam}
                  />
                </div>
              </div>

              <span className="fs-i">
                {t('lessons.editor.embeds.video.audio_note')}
              </span>
            </>
          )}

          <div className="EditorElement-uploadArea">
            <EmbedForm onUrlInput={onUrlInput} onSubmit={onSubmit} isVideo />
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  apiKey: state.editor.ziggeoApiKey,
  currentUserId: state.editor.currentUserId,
});

export default connect(mapStateToProps)(ProviderIndependentVideoEmbed);
